import { useParams, useNavigate } from "react-router-dom";
import { useState } from "react";
import { accessoriesData } from "./accessoires.jsx";
import HeaderBis from "../components/layout/headerbis";
import backgroundImage from "./../assets/img/header1.webp";

export default function AccessoryPage() {
  const { name } = useParams();
  const navigate = useNavigate();
  const product = accessoriesData.find(
    (p) => p.url === decodeURIComponent(name)
  );

  const hasVariants = !!product?.variants?.tailles;
  const [selectedSize, setSelectedSize] = useState(
    hasVariants ? product.variants.tailles[0] : null
  );

  if (!product) {
    return (
      <div className="pt-24 text-center text-gray-700">Accessoire introuvable.</div>
    );
  }

  const handleDevis = () => {
    let commentaireAuto = `Je souhaite obtenir un devis pour : ${product.name}`;
    if (selectedSize) {
      commentaireAuto += ` - Taille : ${selectedSize.taille} - Prix : ${selectedSize.prix}`;
    } else if (product.price) {
      commentaireAuto += ` - Prix : ${product.price}`;
    }
    navigate(`/devis?commentaire=${encodeURIComponent(commentaireAuto)}`);
  };

  return (
    <div>
      <HeaderBis
        backgroundImage={backgroundImage}
        title={product.name}
        desc="Détails de l'accessoire"
      />
      <div className="pt-12 px-4 md:px-16 lg:px-32 bg-gray-50 pb-12">
        <div className="flex flex-col md:flex-row gap-10">
          <div className="md:w-1/2 rounded-3xl overflow-hidden shadow-lg relative">
            <img
              src={product.image}
              alt={product.name}
              className="w-full h-[400px] object-cover"
            />
          </div>

          <div className="md:w-1/2 flex flex-col justify-center">
            <div className="bg-white rounded-2xl shadow-lg p-6 flex flex-col gap-4">
              <p className="text-gray-700 font-bold text-xl">{product.name}</p>
              <p className="text-gray-700">{product.description}</p>

              {hasVariants ? (
                <div className="flex flex-wrap gap-3 mt-2">
                  {product.variants.tailles.map((size) => (
                    <button
                      key={size.taille}
                      onClick={() => setSelectedSize(size)}
                      className={`border rounded-xl py-2 px-4 text-sm transition ${
                        selectedSize?.taille === size.taille
                          ? "bg-[#005478] text-white border-[#005478]"
                          : "hover:bg-gray-200"
                      }`}
                    >
                      {size.taille} – {size.prix}
                    </button>
                  ))}
                </div>
              ) : (
                <p className="text-2xl font-bold text-[#db7d2b] mt-2">
                  Prix : {product.price}
                </p>
              )}
            </div>

            <button
              onClick={handleDevis}
              className="w-72 bg-[#db7d2b] mt-8 text-white py-4 rounded-xl hover:bg-[#b9671c] text-lg font-semibold transition"
            >
              Demander un devis
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
